import { h } from "preact";

import ItemStack from "../../ItemStack";
import ScreenCard, { ScreenCardProps } from "../ScreenCard";

import styles from "./ScreenCardMirror.module.css";

interface Props extends ScreenCardProps {
    numberOfItems: number;
}

function ScreenCardMirrorContent({ ...screenCardProps }: Omit<Props, "numberOfItems">) {
    return (
        <div class={styles.screenCardMirror}>
            <ScreenCard {...screenCardProps} readOnly={true}/>
        </div>
    );
}

function ScreenCardMirror({
    numberOfItems,
    ...screenCardProps
}: Props) {
    return (
        <ItemStack numberOfItems={numberOfItems}>
            <ScreenCardMirrorContent {...screenCardProps}/>
        </ItemStack>
    );
}

export default ScreenCardMirror;
export { ScreenCardMirrorContent };
